import React, { useState, useCallback } from "react";
import { useFormikContext } from "formik";
import styled from "styled-components";
import useHistory from "routing/useHistory";
import Routes from "routing/Routes";
import { Col, Row } from "components/bootstrap";
import { Wizard } from "components/common";
import useEventDefinitionSteps from "components/event-definitions/event-definition-form/useEventDefinitionCommonSteps";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import EventDefinitionFormControls from "components/event-definitions/event-definition-form/EventDefinitionFormControls";
import GitRulesStep from "./GitRulesStep";
import UploadRulesStep from "./UploadRulesStep";
import SummaryStep from "./SummaryStep";
import { PATH_ACTIONS } from "./utils";
const WizardContainer = styled.div`
  margin-bottom: 10px;
`;
function Form({ pathAction, currentUser }) {
  const { isValid, isSubmitting, submitForm, resetForm, validateForm } = useFormikContext();
  const firstStepKey = pathAction;
  const { push } = useHistory();
  const sendTelemetry = useSendTelemetry("new-sigma-event-definition");
  const [activeStep, setActiveStep] = useState(firstStepKey);
  const {
    values: eventDefinition,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const handleChange = useCallback(
    (field, value) => {
      setFieldValue(field, value);
      setFieldTouched(field, true);
    },
    [setFieldValue, setFieldTouched]
  );
  const importStep = {
    key: firstStepKey,
    title: pathAction === PATH_ACTIONS.gitImport ? "Browse Repo" : "Upload Rules",
    component: pathAction === PATH_ACTIONS.gitImport ? /* @__PURE__ */ React.createElement(GitRulesStep, { pathAction: PATH_ACTIONS.gitImport }) : /* @__PURE__ */ React.createElement(UploadRulesStep, { pathAction: PATH_ACTIONS.fileUpload })
  };
  const commonStepProps = {
    key: firstStepKey,
    action: "create",
    eventDefinition,
    onChange: handleChange,
    currentUser
  };
  const hookSteps = useEventDefinitionSteps({
    viewSteps: [importStep],
    commonStepProps,
    hideFieldsStep: true,
    canEdit: true,
    summaryComponent: /* @__PURE__ */ React.createElement(SummaryStep, { pathAction })
  });
  const steps = hookSteps.filter((s) => s.key !== "notifications");
  const stepKeys = steps.map((s) => s.key);
  const activeStepIndex = stepKeys.indexOf(activeStep);
  const openPrevPage = () => {
    var _a;
    sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_PREVIOUS_CLICKED, {
      app_action_value: "previous-button",
      current_step: (_a = steps[activeStepIndex]) == null ? void 0 : _a.title
    });
    if (activeStepIndex > 0) setActiveStep(stepKeys[activeStepIndex - 1]);
  };
  const openNextPage = () => {
    var _a;
    sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_NEXT_CLICKED, {
      app_action_value: "next-button",
      current_step: (_a = steps[activeStepIndex]) == null ? void 0 : _a.title
    });
    if (activeStepIndex < steps.length - 1) setActiveStep(stepKeys[activeStepIndex + 1]);
  };
  const handleSubmit = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_SUMMARY.CREATE_CLICKED, {
      app_action_value: "create-button"
    });
    validateForm().then((formErrors) => {
      if (Object.keys(formErrors).length > 0) {
        return;
      }
      submitForm().then(() => {
        resetForm();
        push(Routes.ALERTS.DEFINITIONS.LIST);
      });
    });
  };
  const handleCancel = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_SUMMARY.CANCEL_CLICKED, {
      app_action_value: "cancel-button"
    });
    resetForm();
    push(Routes.ALERTS.DEFINITIONS.LIST);
  };
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(WizardContainer, null, /* @__PURE__ */ React.createElement(
    Wizard,
    {
      steps,
      activeStep,
      onStepChange: setActiveStep,
      horizontal: true,
      justified: true,
      containerClassName: "",
      hidePreviousNextButtons: true
    }
  )), /* @__PURE__ */ React.createElement(
    EventDefinitionFormControls,
    {
      activeStepIndex,
      action: "create",
      onOpenPrevPage: openPrevPage,
      onOpenNextPage: openNextPage,
      steps,
      onSubmit: handleSubmit,
      onCancel: handleCancel,
      isSubmitting,
      disabledSubmit: !isValid
    }
  )));
}
export default Form;
